import React from 'react';
import PropTypes from 'prop-types';
import Toggle from '../../../common/components/Toggle/Toggle';

export function PermissionStatusToggle({ onToggle, name, disabled, toggled }) {
  const handleToggle = (e, checked) => {
    onToggle(name, checked);
  };

  return <Toggle disabled={disabled} toggled={toggled} onToggle={handleToggle} />;
}

PermissionStatusToggle.propTypes = {
  name: PropTypes.string,
  toggled: PropTypes.bool,
  onToggle: PropTypes.func,
};
